const appInitialState = {
  //hideLibrary: false,
  //isNfrMarket: false,
  selectedCountry: null,
  //isArMarket: false,
  //isVaultMarket: false,
  //loginAgainStatus: false,
  //isCheckoutPipeline: false,
  //hasReferrerId: false,
  //sessionExpired: false,
  //firstName: null,
  //lastName: null,
  isLoading: false,
  //isShopping: true,
  //isAr: false,
  //isTaxIncMarket: false,
  catalogType: "Enroll",
  catalogName: null,
  customerType : "FP",
  lastCompletedStep : null,
};

export default appInitialState;



// WEBPACK FOOTER //
// ./src/store/initialStates/appInitialState.js